import { render, staticRenderFns } from "./net-reviews-site-reviews.component.vue?vue&type=template&id=0d356505&"
import script from "./net-reviews-site-reviews.component.vue?vue&type=script&lang=ts&"
export * from "./net-reviews-site-reviews.component.vue?vue&type=script&lang=ts&"
import style0 from "./net-reviews-site-reviews.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "net-reviews-site-reviews.component.vue"
export default component.exports